import { formatAssetPrice } from '@exodus/formatting/lib/price';
import Text from '@passkeys/ui/text';

import type { Asset } from '@/types';
import useConversion from '@/ui/hooks/use-conversion';
import { cn } from '@/ui/utils/classnames';
import { getFeeLabel } from '@/ui/utils/content';

interface TransactionFeeProps {
  asset: Asset;
  estimatedFee: any;
  monospace?: boolean;
  className?: string;
}

function SendFee({
  asset,
  estimatedFee,
  monospace,
  className,
}: TransactionFeeProps) {
  const feeAsset = asset.feeAsset;

  const fiatConversion = useConversion(feeAsset.name);

  const label = getFeeLabel({
    assetName: feeAsset.name,
    isMax: false,
    displayNetworkName: '',
  });

  return (
    <div className={cn('flex justify-between', className)}>
      <Text size={13} className="opacity-50" monospace={monospace}>
        {label}
      </Text>
      <Text size={13} className="opacity-50" monospace={monospace}>
        {estimatedFee
          ? formatAssetPrice({
              price: fiatConversion(estimatedFee).toDefaultString({
                unit: false,
              }),
              currency: 'USD',
            })
          : '$-.--'}
      </Text>
    </div>
  );
}

export default SendFee;
